import { useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { legalEndpoints } from '@/modules/legal/constants';

import { legalQueryKeys } from './queryKeys';

/**
 * Current legal texts, served by the API so the wording a user confirms is
 * exactly the version their decision is recorded against.
 */
export const useLegalDocumentsQuery = () => {
  return useQuery({
    queryKey: legalQueryKeys.documents(),
    queryFn: async () => {
      const { data } = await fetchClient.GET(legalEndpoints.documents, {});
      return data ?? [];
    },
    staleTime: Infinity,
  });
};
